const certifications = [
  "ISO 9001",
  "ISO 22000",
  "FSSAI Certified",
  "REACH Compliant",
  "GMP Certified",
  "APEDA Registered",
  "BIS Standards",
  "SGS Verified",
  "Halal Certified",
  "HACCP Compliant",
];

export default function StatsSection() {
  const doubled = [...certifications, ...certifications];

  return (
    <section className="py-12 border-t border-b border-border overflow-hidden">
      <div className="container px-4 mb-6">
        <p className="text-center text-base text-muted-foreground font-medium">
          Compliance & quality standards across all verticals
        </p>
      </div>
      <div className="relative">
        <div className="flex animate-marquee whitespace-nowrap">
          {doubled.map((cert, i) => (
            <div
              key={i}
              className="mx-8 flex items-center gap-2 text-muted-foreground/60 shrink-0"
            >
              <span className="text-base font-display font-semibold tracking-tight">
                {cert}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
